import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { SearchListingsGuard } from './guard/search-listings-guard'
import { SearchListingsComponent } from './search-listings'
import { AuthenticationGuard } from '../../guard/authentication'

const routes: Routes = [
    {
        canActivate: [AuthenticationGuard, SearchListingsGuard],
        component: SearchListingsComponent,
        path: ''
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SearchListingsRoutingModule {}
